export const incomingRequests = {

  "title": "Matching intelligent",
  "subtitle": "Découvrez les membres qui souhaitent visiter votre région",
  "requests": {
    "title": "Demandes",
    "count": "{{count}} demande(s)",
    "empty": {
      "noListingDescription": "Vous n'avez pas encore d'annonce. Publiez-en une pour recevoir des demandes."
    },
    "loading": "Chargement des demandes...",
    "errors": {
      "notAuthenticated": "Vous devez être connecté pour voir cette page.",
      "loadFailed": "Une erreur est survenue lors du chargement des demandes."
    },
    "defaultPropertyType": "Logement",
    "sortOptions": {
      "recent": "Plus récents",
      "rating": "Mieux notés",
      "distance": "Plus proches"
    }
  },
  "aiSection": {
    "title": "Suggestions intelligentes",
    "subtitle": "Découvrez les membres qui correspondent à vos critères",
    "distance": "Distance",
    "dates": "Dates",
    "guests": "Voyageurs",
    "matchScore": "Score de compatibilité",
    "search": "Rechercher",
    "startDiscussion": "Démarrer la discussion",
    "viewProfile": "Voir le profil",
    "away": "de distance"
  }
};
